import { Center } from '@chakra-ui/react';
export default function NotFoundPage({ minH }) {
  return (
    <Center minH={minH} fontWeight="bold" fontSize={58}>
      <h1>404 Not Found</h1>
    </Center>
  );
}
